document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.visual-hotspots');
  const URL_PARAM_KEY = 'vh';

  function getUrlActiveHotspotId() {
    const params = new URLSearchParams(window.location.search);
    return params.get(URL_PARAM_KEY);
  }

  function setUrlActiveHotspotId(hotspotId) {
    if (!hotspotId) return;
    const url = new URL(window.location.href);
    url.searchParams.set(URL_PARAM_KEY, hotspotId);
    window.history.replaceState({}, '', url);
  }

  sections.forEach((section) => {
    const buttons = section.querySelectorAll('.vh-header-button');
    const contentItems = section.querySelectorAll('.vh-content-item');

    function showContentById(targetId) {
      contentItems.forEach((item) => {
        item.classList.toggle('active', item.dataset.visualHotspotId === targetId);
      });
    }

    function setActiveButton(clickedButton) {
      buttons.forEach((btn) => btn.classList.remove('active'));
      clickedButton.classList.add('active');
    }

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = this.dataset.visualHotspotId;
        if (!targetId) return;
        setActiveButton(this);
        showContentById(targetId);
        setUrlActiveHotspotId(targetId);
      });
    });

    const activeFromUrl = getUrlActiveHotspotId();
    const buttonFromUrl = activeFromUrl
      ? section.querySelector(`.vh-header-button[data-visual-hotspot-id="${activeFromUrl}"]`)
      : null;
    const firstButton = buttonFromUrl || section.querySelector('.vh-header-button.active') || buttons[0];

    if (firstButton && firstButton.dataset.visualHotspotId) {
      const targetId = firstButton.dataset.visualHotspotId;
      setActiveButton(firstButton);
      showContentById(targetId);

      if (!activeFromUrl || activeFromUrl !== targetId) {
        setUrlActiveHotspotId(targetId);
      }
    }
  });
});

